import { useCallback, useSyncExternalStore } from 'react';
import type { AdapterSnapshot, TableAdapter } from '../../ports';

export function useAdapter<T>(adapter: TableAdapter<T>): AdapterSnapshot<T> {
    const subscribe = useCallback(
        (listener: () => void) => adapter.subscribe(listener),
        [adapter],
    );
    return useSyncExternalStore(subscribe, adapter.getSnapshot);
}
